import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const TokenHandler = () => {
    const { login } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const [processing, setProcessing] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const processUrlParams = async () => {
            // Only process if we have query parameters
            if (!location.search) {
                return;
            }

            const params = new URLSearchParams(location.search);
            const token = params.get('token');
            const notoken = params.get('notoken');

            // Check if we have either token or notoken parameter
            if (!token && !notoken) {
                return;
            }

            setProcessing(true);
            setError(null);

            try {
                // Handle notoken parameter (bypass mode)
                if (notoken && notoken === '1') {
                    console.log('Processing notoken parameter - bypass mode');
                    const bypassToken = 'pass';
                    const success = login(bypassToken);

                    if (success) {
                        // Clean URL and redirect
                        navigate('/dashboard', { replace: true });
                    } else {
                        throw new Error('Failed to authenticate with bypass token');
                    }
                    return;
                }

                // Handle regular token parameter
                if (token) {
                    console.log('Processing token parameter');
                    const success = login(token);

                    if (success) {
                        // Clean URL and redirect to dashboard
                        navigate('/dashboard', { replace: true });
                    } else {
                        throw new Error('Invalid or expired token');
                    }
                    return;
                }
            } catch (err) {
                console.error('Token processing error:', err);
                setError(err.message || 'Authentication failed');

                // Redirect to login after error
                setTimeout(() => {
                    navigate('/login', { replace: true });
                }, 2000);
            } finally {
                setProcessing(false);
            }
        };

        processUrlParams();
    }, [location.search, login, navigate]);

    // Show loading or error state if processing
    if (processing) {
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(var(--ink-overlay-rgb), 0.9)',
                zIndex: 9999
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">Procesando autenticación...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(var(--ink-overlay-rgb), 0.9)',
                zIndex: 9999
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div className="alert alert-danger" role="alert">
                        <h4 className="alert-heading">Error de autenticación</h4>
                        <p>{error}</p>
                        <hr />
                        <p className="mb-0">Redirigiendo al login...</p>
                    </div>
                </div>
            </div>
        );
    }

    return null;
};

export default TokenHandler;
